class CookieHelper {
    // A collection of methods to handle cookies - set, get and delete
    static setCookie(name: string, value: string, daysTillExpire: number, path: string = '/'): void {
        const date: Date = new Date()
        date.setTime(date.getTime() + (daysTillExpire * 24 * 60 * 60 * 1000));
        const expires: string = date.toUTCString();
        document.cookie = `${name}=${value};expires=${expires};path=${path};`
    }

    static getCookie(cname: string): string | null {
        console.log(`were looking for the cookie: ${cname}`)
        let name = cname + "="
        let decodedCookie = decodeURIComponent(document.cookie)
        let ca = decodedCookie.split(';')
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i]
            while (c.charAt(0) === ' ') {
                c = c.substring(1)
            }
            if (c.indexOf(name) === 0) {
                console.log(c.substring(name.length, c.length))
                return c.substring(name.length, c.length)
            }
        }
        return "";
    }

    // static deleteCookie(name: string, path: string = '/'): void {
    //     document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${path};`
    // }
}

class UrlHelper {
    private url: URL;

    constructor(urlString = window.location.href) {
        this.url = new URL(urlString);  // Each instance gets its own URL
    }

    static deleteUrlParameter(urlString: string, param: string): string {
        const url = new URL(urlString);
        url.searchParams.delete(param);
        return url.toString();
    }

    // Instance method example
    updateUrlString(param: string, value: string): string {
        this.url.searchParams.set(param, value);
        return this.url.toString();
    }

    // Instance method example
    updateWindowUrl(param: string, value: string | undefined): string {
        value === undefined ? value = '' : value;
        this.url.searchParams.set(param, value);
        window.history.pushState(null, '', this.url.toString());
        return this.url.toString();
    }

    updateWindowLocation(urlString: string) {
        window.history.pushState(null, '', urlString);
    }

    getUrlParameter(param: string) {
        return this.url.searchParams.get(param);
    }
}

function ajaxHTML(id: string, url: string, append: boolean): void {
    fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text();
        })
        .then(html => {
            const ajaxEl: HTMLElement | null = document.getElementById(id);
            if (ajaxEl) {
                if (append) {
                    console.log("Appending content");
                    ajaxEl.innerHTML += html;
                } else {
                    ajaxEl.innerHTML = html;
                }
            }
        })
        .catch(error => {
            console.error('There has been a problem with your fetch operation:', error);
        });
}


import initCarousel from './modules/carousel'

document.addEventListener('DOMContentLoaded',
    (): void => {
        console.log('DOMContentLoaded');
        // should replace the carousel library with alpine at some point, but it's working, so we're going to leave it for now
        initCarousel();


        // widgets!
        // FUTURES
        async function setupFutures() {
            if (document.getElementById('dtnFutures')) {
                // @ts-ignore
                await new Promise((res: TimerHandler) => setTimeout(res, 500));
                // @ts-ignore
                return await window.dtn.futures.createFuturesTableWidget({
                    "apiKey": "qyyGKtOc1p0aAhKwDtOBREwfrpxEAK5p",
                    "container": "#dtnFutures",
                    "symbol": "@S`##",
                    "visibleFields": [
                        "LAST",
                        "CHANGE",
                        "HIGH",
                        "LOW",
                        "LAST_UPDATE",
                        "SETTLE_DATE",
                        "SETTLE_PRICE"
                    ],
                    "groupBy": true,
                    "priceFormat": "TICK",
                    "timezone": "CST",
                });
            } else {
                return null;
            }
        }

        // wait for the table to resolve
        setupFutures().then((res) => {
            if (res === null || res === undefined) {
                console.log('No dtnFutures on page');
            } else {
                console.log('dtnFutures initilized');
                const dtnTickerSelectEl = document.getElementById('dtnTickerSelect') as HTMLInputElement;
                if (dtnTickerSelectEl) {
                    dtnTickerSelectEl.addEventListener('change', (e) => {
                        // @ts-ignore
                        res.setSymbol(e.target.value);
                    })
                }
            }
        });


        // CASH BIDS
        if (document.getElementById('dtnCashBids')) {
            // get the default location
            const defaultLocation = CookieHelper.getCookie('default_location') ?? 'Sioux Center';
            setupCashBids(defaultLocation).then(() => {
                const delay = (ms: number) => {
                    // @ts-ignore
                    return new Promise((resolve: any) => setTimeout(resolve, ms));
                }
                delay(2000).then(() => {
                    const dropdownEl = document?.querySelectorAll("[label='Locations']")[0];
                    if (dropdownEl) {
                        dropdownEl.insertAdjacentHTML('beforebegin', `<p class="text-xs">Your default location will always be the location you selected last!</p>`)
                    }
                    dropdownEl.addEventListener('change', () => {
                        // @ts-ignore
                        const dropdownValue = dropdownEl?.select?.value;
                        console.log(`the dropdown changed to ${dropdownValue}!`);
                        CookieHelper.setCookie('default_location', dropdownValue, 7);
                    });
                });
            });
        } else {
            console.log('No dtnCashBids on page')
        }

        async function setupCashBids(location: string) {
            // @ts-ignore
            await new Promise((res: TimerHandler) => setTimeout(res, 500));
            // @ts-ignore
            return await window.dtn.cashBids.createCashBidsTableWidget({
                "apiKey": "LoRsplCyyusLardtZwVPueT8gFnDZCZu",
                "container": "#dtnCashBids",
                "siteId": "E0014201",
                "groupBy": "LOCATION",
                "showGroupByOptions": true,
                "view": "DETAIL",
                "showViewOptions": true,
                "showLocationsSelect": true,
                "showCommoditiesSelect": true,
                "defaultLocation": {
                    "locationName": location
                },
                "hideCommodities": [
                    "Canola"
                ],
                "hideLocations": [
                    "McNally"
                ],
                "deliveryDateFormat": "DELIVERY_LABEL",
                "visibleFields": [
                    // "DELIVERY_START",

                    "CASH_PRICE",
                    "BASIS_PRICE",
                    "SYMBOL",
                    "FUTURES_QUOTE",
                    "FUTURES_CHANGE"
                ]
            });
        }

        // WEATHER
        if (document.getElementById('dtnWeather')) {
            setupWeather().then(() => console.log('dtnWeather initialized!'))
        }

        async function setupWeather() {
            // @ts-ignore
            await new Promise((res: TimerHandler) => setTimeout(res, 500));
            // @ts-ignore
            return await window.dtn.localWeather.createLocalWeatherWidget({
                "apiKey": "nHOS9jOLnv5LVRnugD7kKkFlECbUsTAI",
                "container": "#dtnWeather",
                "units": "Imperial",
                "defaultLocation": {
                    "postalCode": "57072"
                },
                "showStationsSelect": false,
                "showPostalCodeInput": true,
                "showForecast": true,
                "showCurrentConditions": true,
                "showWeatherDetails": true,
                "callbacks": {
                    "onStationChange": "",
                    "onPostalCodeChange": "",
                    "onWeatherChange": ""
                }
            });
        }

        // NEWS LIST
        if (document.getElementById('dtnNews')) {
            setupNews().then(() => console.log('dtnNews initilized'));
        }

        async function setupNews() {
            // @ts-ignore
            await new Promise((res: TimerHandler) => setTimeout(res, 500));
            // @ts-ignore
            return await window.dtn.news.createNewsListWidget({
                "apiKey": "2vyCn0fQ8l54GPAYb8NyzGVpflMzlP9k",
                "container": "#dtnNews",
                "categories": [
                    "DTN_AG",
                    "MARKETS",
                    "GRAIN",
                    "CORN",
                    "SOYBEANS"
                ],
                "maximumArticleCount": 8,
                "displayArticle": false
            });

        }

        if (document.getElementById('dtnNewsFull')) {
            setupNewsFull().then(() => console.log('dtnNewsFull initilized'));
        }

        async function setupNewsFull() {
            // @ts-ignore
            await new Promise((res: TimerHandler) => setTimeout(res, 500));
            // @ts-ignore
            return await window.dtn.news.createNewsListWidget({
                "apiKey": "2vyCn0fQ8l54GPAYb8NyzGVpflMzlP9k",
                "container": "#dtnNewsFull",
                "categories": [
                    "DTN_AG",
                    "MARKETS",
                    "GRAIN",
                    "CORN",
                    "SOYBEANS"
                ],
                "maximumArticleCount": 100,
                "displayArticle": false
            });
        }


        const myUrlHelper = new UrlHelper();

        // Global AJAX Variables
        const defaultCashBidsLocation = CookieHelper.getCookie(('default_cash_bids_location'));
        const locationPathName = window.location.pathname;

        // Update the content based on if there's an explicit location or not
        function updateContentViaLocation(defaultLocation: string) {
            ajaxHTML('js-dtn-bids', `/ajax/homepage/dtn-cash-bids?location=${defaultLocation}`, false);
            // clear the search params (set them to nothing)
            const urlCleanParams = myUrlHelper.updateUrlString('', '');
            const grainBidElems: NodeListOf<HTMLLinkElement> = document.querySelectorAll('a.js-grain-bids-details')
            grainBidElems.forEach(link => {
                // how to access or define href in ts?
                link.href = `${urlCleanParams}dtn-cash-bids?location=${defaultCashBidsLocation}`;
            })

            if (locationPathName === '/dtn-cash-bids') {
                const cashBidsLocationInput = <HTMLInputElement>document.getElementById('cash-bids-location');
                const cashBidsTitle = document.getElementById('cash-bids-title');
                if (cashBidsLocationInput.value && cashBidsTitle) {
                    cashBidsLocationInput.value = defaultCashBidsLocation ? defaultCashBidsLocation : '';
                    cashBidsTitle.textContent = defaultCashBidsLocation;
                }
                ajaxHTML('js-cash-bids-details', `/ajax/pages/dtn-cash-bids?location=${defaultCashBidsLocation}`, false);
            }
        }

        // Function to handle the scenario when no default location is provided
        function handleNoDefaultLocation() {
            ajaxHTML('js-dtn-bids', '/ajax/homepage/dtn-cash-bids', false);
            const cashBidsLocParam = myUrlHelper.getUrlParameter('location');
            const ajaxURL = cashBidsLocParam ? `/ajax/pages/dtn-cash-bids?location=${cashBidsLocParam}` : '/ajax/pages/dtn-cash-bids';
            ajaxHTML('js-cash-bids-details', ajaxURL, false);
        }

        // Main logic to decide which function to call based on `defaultCashBidsLocation`
        if (defaultCashBidsLocation) {
            updateContentViaLocation(defaultCashBidsLocation);
        } else {
            handleNoDefaultLocation();
        }

        // Handles UI updates for cash bids
        // target the default location, the table element (now a Tabbed Block), and the Title
        function updateCashBidsUI(defaultCashBidsLocation: string, tableId: string) {
            // things we need to update: The title, the tables
            // also need to select the correct tab, now

            // const cashBidsTitle = document.getElementById(titleId);
            // if (cashBidsTitle) cashBidsTitle.textContent = defaultCashBidsLocation;
            ajaxHTML(tableId, `/ajax/homepage/dtn-cash-bids?location=${defaultCashBidsLocation}`, false);
            myUrlHelper.updateWindowUrl('location', defaultCashBidsLocation);
        }

        // Set the default location for cash bids
        function updateDefaultBidsLocation() {
            const updateCashBidsDetailsButton = document.getElementById('update-cash-bids-details');
            const cashBidLocationInput = document.getElementById('cash-bid-location') as HTMLInputElement;
            const defaultCashBidsLocation = cashBidLocationInput.value;
            if (updateCashBidsDetailsButton) {
                updateCashBidsDetailsButton.addEventListener('click', () => {
                    if (defaultCashBidsLocation) {
                        if (navigator.cookieEnabled) {
                            CookieHelper.setCookie("default_cash_bids_location", defaultCashBidsLocation, 100, "/");
                        } else {
                            alert('Cookies must be enabled to set a default location.');
                        }
                    }
                });
            } else {
                console.log('Button to update cash bids is not defined! Designate by assigning an element an ID of "update-cash-bids-details"');
            }

        }

        // General function to handle cash bid location selection
        function handleCashBidsSelection(event: Event, targetId: string) {
            const inputElement = event.target as HTMLInputElement;
            const defaultCashBidsLocation = inputElement.value;
            updateCashBidsUI(defaultCashBidsLocation, targetId);
        }

        // Saves the default location in a cookie
        function saveDefaultLocation(event: Event) {
            const element = event.target as HTMLInputElement;
            const defaultCashBidsLocation = element.value;
            if (defaultCashBidsLocation && navigator.cookieEnabled) {
                CookieHelper.setCookie("default_cash_bids_location", defaultCashBidsLocation, 100, "/");
            } else {
                alert('Cookies must be enabled to set a default location.');
            }
        }

        // Attaching event listeners
        function attachListeners() {
            const cashBidLocationInputHome = document.getElementById('cash-bid-location');
            const cashBidLocationInputPage = document.getElementById('cash-bids-location');
            const submitButton = document.getElementById('submit-cash-bids');
            const updatedDetailsButton = document.getElementById('updated-cash-bids-details');

            cashBidLocationInputHome?.addEventListener('change', event => handleCashBidsSelection(event, 'js-dtn-bids'));
            cashBidLocationInputPage?.addEventListener('change', event => handleCashBidsSelection(event, 'js-cash-bids-details'));
            submitButton?.addEventListener('click', saveDefaultLocation);
            updatedDetailsButton?.addEventListener('click', updateDefaultBidsLocation);
        }

        attachListeners();

        // Homepage DTN News
        ajaxHTML('js-dtn-news', '/ajax/homepage/dtn-news', false);

        // DTN News Feed
        if (locationPathName === '/dtn-news') {
            const activeLink = document.querySelector('a#dtn-cat-link.active');
            if (activeLink) {
                const activeNews = activeLink.getAttribute('href');
                const activeNewsCat = activeNews?.split('=')[1];

                ajaxHTML('js-dtn-news-feed', `/ajax/news${activeNews}`, false);
                const updatedWindowUrl = myUrlHelper.updateWindowUrl('service', activeNewsCat);
                myUrlHelper.updateWindowLocation(updatedWindowUrl);
            }
        }

        // Handle clicks on category links
        document.querySelectorAll('a#dtn-cat-link').forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();
                const activeNews = link.getAttribute('href');
                const activeNewsCat: string | undefined = activeNews?.split('=')[1];

                // Update active class
                document.querySelectorAll('a#dtn-cat-link.active').forEach(active => {
                    active.classList.remove('active');
                });
                link.classList.add('active');

                ajaxHTML('js-dtn-news-feed', `/ajax/news${activeNews}`, false);
                const updatedWindowUrl = myUrlHelper.updateWindowUrl('service', activeNewsCat);
                myUrlHelper.updateWindowLocation(updatedWindowUrl);
            });
        });

        // DTN News Story
        if (locationPathName === '/dtn-news/entry') {
            const storyId = myUrlHelper.getUrlParameter('storyId');
            const service = myUrlHelper.getUrlParameter('service');
            ajaxHTML('js-dtn-news-story', `/ajax/news/dtn-news-story?storyId=${storyId}&service=${service}`, false);
            ajaxHTML('js-dtn-single-related-news', `/ajax/news/dtn-related-news?service=${service}`, false);
        }

        // DTN Page Related News
        ajaxHTML('js-dtn-related-news', '/ajax/pages/dtn-news', false);
    })